<lib-input-wrapper [ionItemWrap]="ionItemWrap" [disabled]="disabled">
    <ng-content *ngTemplateOutlet="checkboxContent"></ng-content>
</lib-input-wrapper>

<ng-template #checkboxContent>
    <div
        class="input input-checkbox"
        [ngClass]="{
            'input-checkbox-disabled': disabled && !ionItemWrap
        }"
        [formGroup]="form">
        <p class="input-checkbox--stacked-label" *ngIf="label">{{ label }}</p>
        <ion-checkbox
            (ionChange)="onChange($event)"
            slot="start"
            [formControlName]="controlName || null"
            mode="md"
            alignment="center"
            justify="start"
            labelPlacement="end"
            [checked]="checked"
            [disabled]="disabled"
            [indeterminate]="indeterminate"
            [ngClass]="{
                'checkbox-checked': checked,
                'input-checkbox--color-primary': color === 'primary',
                'hide-content': hideContent
            }">
            <div class="input-checkbox-checkbox">
                <lib-svg-icon
                    iconName="checkmark-round"
                    class="input-checkbox-icon-checkmark"
                    color="white"
                    [size]="11" />
                <lib-svg-icon iconName="minus-thick" class="input-checkbox-icon-minus" color="white" [size]="11" />
            </div>
            <div *ngIf="!hideContent" class="ion-padding-start ion-text-wrap input-checkbox--content">
                <ng-content></ng-content>
            </div>
            <div *ngIf="hideContent" class="input-checkbox--content">{{ checked ? 'checked' : 'unchecked' }}</div>
        </ion-checkbox>
    </div>

    <div *ngIf="formInput && formInput.errors && submitAttempt">
        <p *ngIf="formInput.errors['required']" class="invalid-text">Required field</p>
        <p *ngIf="!formInput.errors['required']" class="invalid-text">Please check this field again</p>
    </div>

    <ng-content select="[formMessages]"></ng-content>

    <div class="invalid-text">
        <ng-content select="[formErrorMessages]"></ng-content>
    </div>
</ng-template>
